class SearchForm extends HTMLElement {
  /**
   * Initializes the SearchForm component.
   */
  constructor() {
    super();

    this.DEBOUNCE_INTERVAL = 300;
    this.IS_ACTIVE_CLASS = "search--active";
  }

  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    if (this.input) this.addListeners();
  }

  /**
   * Adds event listeners for input and reset button.
   */
  addListeners() {
    this.searchToggles?.forEach((toggle) => {
      toggle.addEventListener("click", () => this.toggleSearchButton());
    });

    this.exitButtons?.forEach((button) => {
      button.addEventListener("click", (event) => this.searchExit(event));
    });

    this.input.addEventListener("input", this.onChange.bind(this));
  }

  /**
   * Sets search form to active state when clicked
   */
  setSearchState(action) {
    if (action !== "add" && action !== "remove") return;

    if (action == "add" && document.querySelector("side-drawer-toggle")) {
      document.querySelector("side-drawer-toggle").closeAllDrawers();
    }

    if (
      action == "add" &&
      document.body.classList.contains("megamenu--active")
    ) {
      document.body.classList.remove("megamenu--active");
    }

    this.classList[action](this.IS_ACTIVE_CLASS);
    this.searchToggles?.forEach((toggle) => toggle.classList[action]("search-toggle--active"));
    document.body.classList[action]("blur", "blur--body-only");

    if (action == "add") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }

  /**
   * Handles input change events.
   */
  onChange() {
    this.setSearchState("add");
  }

  /**
   * Handles form reset, clears input and removes active state.
   * @param {Event} event - The reset event.
   */
  onFormReset(event) {
    event.preventDefault();

    this.input.value = "";
    this.setSearchState("remove");
  }

  /**
   * Exits search, delegates to onFormReset.
   * @param {Event} event - The click event.
   */
  searchExit(event) {
    this.onFormReset(event);
  }

  toggleSearchButton() {
    const isActive = this.classList.contains(this.IS_ACTIVE_CLASS);
    this.setSearchState(isActive ? "remove" : "add");
  }

  /**
   * Returns the search form element.
   */
  get form() {
    return this.querySelector("[data-search-form]");
  }

  /**
   * Returns the search input element.
   */
  get input() {
    return this.querySelector("[data-search-input]");
  }

  /**
   * Returns the search toggle elements.
   */
  get searchToggles() {
    return document.querySelectorAll("[data-search-toggle]");
  }

  /**
   * Returns the exit button elements.
   */
  get exitButtons() {
    return this.querySelectorAll("[data-search-exit]");
  }
}

customElements.define("search-form", SearchForm);
